/**
 * ลิงก์ไปหน้าผู้จำหน่าย / ใบส่งซ่อม — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลในหน้ารายการ)
 *   /master-data/suppliers            รายการผู้จำหน่าย
 *   /master-data/suppliers/:id        รายละเอียด (suppliers.view)
 *   /master-data/suppliers/:id/edit   แก้ไข (suppliers.view + suppliers.edit)
 *   /master-data/suppliers/new        เพิ่มใหม่ (suppliers.create)
 *   /supplier-repairs                 ติดตามการส่งซ่อม (?supplier=<id> = กรองตามผู้จำหน่าย)
 *   /supplier-repairs/:id             รายละเอียดใบส่งซ่อม (supplier_repairs.view)
 *   /supplier-repairs/:id/edit        แก้ไขใบส่งซ่อม (supplier_repairs.view + supplier_repairs.edit)
 *   /supplier-repairs/new             สร้างใบส่งซ่อม (supplier_repairs.create)
 * ใช้ helper นี้ทุกที่ที่ลิงก์ไป เพื่อให้ URL contract อยู่ที่เดียว (แบบ utils/companyLinks.ts)
 */
export const SUPPLIERS_PATH = '/master-data/suppliers';
export const SUPPLIER_NEW_PATH = `${SUPPLIERS_PATH}/new`;
export const SUPPLIER_REPAIRS_PATH = '/supplier-repairs';
export const SUPPLIER_REPAIR_NEW_PATH = `${SUPPLIER_REPAIRS_PATH}/new`;

const validId = (id: number | string | null | undefined): number | null => {
  const n = Number(id);
  return Number.isInteger(n) && n > 0 ? n : null;
};

/** หน้ารายละเอียดผู้จำหน่าย — id ไม่ถูกต้อง = หน้ารายการ */
export function supplierDetailUrl(supplierId: number | string | null | undefined): string {
  const n = validId(supplierId);
  return n ? `${SUPPLIERS_PATH}/${n}` : SUPPLIERS_PATH;
}

export function supplierEditUrl(supplierId: number | string | null | undefined): string {
  const n = validId(supplierId);
  return n ? `${SUPPLIERS_PATH}/${n}/edit` : SUPPLIERS_PATH;
}

/** หน้ารายละเอียดใบส่งซ่อม — id ไม่ถูกต้อง = หน้ารายการ */
export function supplierRepairDetailUrl(repairId: number | string | null | undefined): string {
  const n = validId(repairId);
  return n ? `${SUPPLIER_REPAIRS_PATH}/${n}` : SUPPLIER_REPAIRS_PATH;
}

export function supplierRepairEditUrl(repairId: number | string | null | undefined): string {
  const n = validId(repairId);
  return n ? `${SUPPLIER_REPAIRS_PATH}/${n}/edit` : SUPPLIER_REPAIRS_PATH;
}

/** รายการใบส่งซ่อมที่กรองเฉพาะผู้จำหน่ายรายนี้ */
export function supplierRepairsBySupplierUrl(supplierId: number | string | null | undefined): string {
  const n = validId(supplierId);
  return n ? `${SUPPLIER_REPAIRS_PATH}?supplier=${n}` : SUPPLIER_REPAIRS_PATH;
}
